import * as React from "react";
const ClearXSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "currentColor", width: size || "16", height: size || "16", ...props }, /* @__PURE__ */ React.createElement("circle", { cx: "8", cy: "8", r: "8", opacity: ".06" }), /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M12 4.707L11.293 4 8 7.293 4.707 4 4 4.707 7.293 8 4 11.293l.707.707L8 8.707 11.293 12l.707-.707L8.707 8 12 4.707z" }));
ClearXSmall.displayName = "ClearXSmall";
var ClearXSmall_default = ClearXSmall;
export {
  ClearXSmall_default as default
};
